import React, { Component } from 'react';
import { Row, Col, Skeleton, Card, Spin } from 'antd';
import { inject, observer } from 'mobx-react';
import { CandleChart } from './Chart';
import { OrderBook } from './OrderBook';
import { RecentTrades } from './RecentTrades';
import { Positions } from './Positions';

@inject('store')
@observer
export class TradeView extends Component {
    componentDidMount() {
        this.props.store.odysseyBotStore.getActiveTradingSession(this.props.match.params.id);
    }

    render() {
        const { activeTradingSession } = this.props.store.odysseyBotStore;

        if (!activeTradingSession) {
            return (
                <Row gutter={24}>
                    <Col md={18}>
                        <Spin size="large" tip="Waiting for active trading session">
                            <Card
                                size={'small'}
                                bordered={false}
                                style={{ height: 700, marginBottom: 15 }}
                                bodyStyle={{ height: '100%' }}
                            >
                                <Skeleton active paragraph={{ rows: 18 }} />
                            </Card>
                        </Spin>
                    </Col>
                    <Col md={6}>
                        <Card title={'Orderbook'} bordered={false} style={{ marginBottom: 15 }}>
                            <Skeleton active />
                        </Card>

                        <Card title={'Recent Trades'} bordered={false}>
                            <Skeleton active />
                        </Card>
                    </Col>
                    <Col md={24}>
                        <Skeleton />
                    </Col>
                </Row>
            );
        }
        return (
            <Row gutter={24}>
                <Col md={18}>
                    {activeTradingSession ? (
                        <CandleChart symbol={activeTradingSession.trading_pair} />
                    ) : null}
                </Col>
                <Col md={6}>
                    <OrderBook />
                    <RecentTrades />
                </Col>
                <Col md={24}>
                    <Positions />
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/TradeView/index.js